import { render, staticRenderFns } from "./SalaryRegister.vue?vue&type=template&id=9199474e&scoped=true"
import script from "./SalaryRegister.vue?vue&type=script&lang=js"
export * from "./SalaryRegister.vue?vue&type=script&lang=js"
import style0 from "./SalaryRegister.vue?vue&type=style&index=0&id=9199474e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9199474e",
  null
  
)

export default component.exports